module.exports = __webpack_public_path__ + "img/logo.9cbef480.png";